import { SET_CONSTANT, SET_EVENT, UPDATE_EVENT, APPLY_CHANGES } from '../config/actionTypes';

const initialState = {
    kitVersion: '',
    cloudIp: '',
    events: [],
    isOpenApplyModal: false,
    eventUtils: {},
    isExchangeExpired: false
};

const ConstantReducer = (state = initialState, action) => {
	const { data, type } = action;
	switch (type) {
        case SET_CONSTANT:
			return {
                ...state,
                ...data
            };
        case SET_EVENT:
			return {
                ...state,
                ...data
            };
        case UPDATE_EVENT:
            return {
                ...state,
                events: [
                    ...state.events,
                    ...data
                ]
            };
        case APPLY_CHANGES:
            return {
                ...state,
                isOpenApplyModal: data.isOpenApplyModal
            };
		default:
			return state;
	}
};

export default ConstantReducer;
